// extracted by mini-css-extract-plugin
export default {"subscriptionList":"SubscriptionList_subscriptionList__5MNZf"};